import { reviews } from '@/mocks/manga';

export default function Reviews() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-accent-100 text-accent-700 text-xs font-medium px-3 py-1 rounded-full mb-4">
            <i className="ri-double-quotes-l text-sm w-4 h-4 flex items-center justify-center"></i>
            读者口碑
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            漫友们的真实评价
          </h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">
            来自全国各地漫画爱好者的真诚反馈，是我们不断进步的动力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {reviews.slice(0, 3).map((review) => (
            <div key={review.id} className="bg-background-50 rounded-2xl p-5 md:p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={review.avatar} alt={review.userName} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{review.userName}</p>
                  <div className="flex items-center gap-0.5">
                    {Array.from({ length: review.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-primary-500 text-xs"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{review.content}</p>
            </div>
          ))}
        </div>

        <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {reviews.slice(3).map((review) => (
            <div key={review.id} className="bg-background-50 rounded-2xl p-5 md:p-6">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={review.avatar} alt={review.userName} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{review.userName}</p>
                  <div className="flex items-center gap-0.5">
                    {Array.from({ length: review.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-primary-500 text-xs"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{review.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}